import React from 'react';
import { BrowserRouter, Routes as ReactRoutes, Route,Navigate } from "react-router-dom";
import Login from "pages/login"
import SignUp from "pages/sign-up"
import ForgotPassword from "pages/forgot-password"
import ResetPassword from "pages/reset-password"
import Dashboard from "pages/dashboard"
import RequestOrders from "pages/request-orders-new"
import RequestPickupOrders from "pages/request-pickup-orders"
import ManageOrders from "pages/manage-orders"
import ManageAccount from 'pages/manage-account';
import InvoicePage from 'pages/invoicePage'

const Routes = () => {
  return (
    <BrowserRouter>
      <ReactRoutes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/confirm-password" element={<ResetPassword />} />      
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/request-orders" element={<RequestOrders />} />
        <Route path="/request-pickup-orders" element={<RequestPickupOrders />} />
        <Route path="/manage-orders" element={<ManageOrders />} />
        <Route path="/manage-account" element={<ManageAccount />} />
        <Route path ="/invoices" element={<InvoicePage/>}  />  
        <Route path="*" element={<Navigate to="/login" replace />} />
      </ReactRoutes>
    </BrowserRouter>
  );
};

export default Routes;